import React, { useEffect, useRef } from 'react';

function TurnstileWidget({ siteKey, onToken }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!siteKey || !ref.current) return undefined;

    const render = () => {
      if (!window.turnstile || !ref.current) return;
      ref.current.innerHTML = '';
      window.turnstile.render(ref.current, {
        sitekey: siteKey,
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(''),
        'error-callback': () => onToken(''),
      });
    };

    if (window.turnstile) {
      render();
      return undefined;
    }

    const existing = document.querySelector('script[data-turnstile]');
    if (existing) {
      existing.addEventListener('load', render);
      return () => existing.removeEventListener('load', render);
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.dataset.turnstile = 'true';
    script.addEventListener('load', render);
    document.body.appendChild(script);
    return () => script.removeEventListener('load', render);
  }, [siteKey, onToken]);

  return <div ref={ref} className="my-2" />;
}


export default TurnstileWidget;
